import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, OnDestroy, Inject} from '@angular/core';
import {DOCUMENT} from "@angular/common";
import {animate, style, transition, trigger} from '@angular/animations';
import { AppService } from 'src/app/core/services/app.service';

declare const window:any;
@Component({
  selector: 'bit-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  animations: [
    trigger('fade', [
      transition(':enter', [
        style({
          opacity: 0,
        }),
        animate('150ms', style({ opacity: 1 })),
      ]),
      transition(':leave', [
        style({
          opacity: 1,
        }),
        animate('150ms', style({ opacity: 0 })),
      ]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderComponent implements OnInit, OnDestroy {
  menuToggle = false;
  isLanguageMenuVisible = false;
  isCryptoListOpen = false;

  markets$ = this.appService.getMarketList('IRR')

  constructor(private cd: ChangeDetectorRef, @Inject(DOCUMENT) private document: Document, public appService: AppService) {
  }

  toggleMenu() {
    this.menuToggle = !this.menuToggle;
    this.document.body.style.overflow = this.menuToggle ? 'hidden' : 'auto';
    this.cd.markForCheck();
  }

  openSupport($event: any) {
    $event.preventDefault();
    $event.stopImmediatePropagation();
    if (window.Goftino) {
      window.Goftino.open();
    }
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.document.body.style.overflow = 'auto';
  }

  handleCryptoListClose() {
    setTimeout(() => {
      if (this.isCryptoListOpen) {
        this.isCryptoListOpen = false;
      }
    }, 0);
  }


}
